import { useSyncExternalStore } from 'react'

/** Shell overlays that more than one place opens (keys, top bar, tab bar). The shell owns the omnibar's state. */
type Overlay = 'omnibar' | 'shortcuts' | 'more'

let open: Overlay | null = null
const listeners = new Set<() => void>()

function set(next: Overlay | null) {
  open = next
  listeners.forEach((l) => l())
}

export const openOverlay = (o: Overlay) => set(o)
export const closeOverlay = () => set(null)
export const toggleOverlay = (o: Overlay) => set(open === o ? null : o)

export function useOverlay(o: Overlay): boolean {
  return useSyncExternalStore(
    (l) => {
      listeners.add(l)
      return () => listeners.delete(l)
    },
    () => open === o,
  )
}
